'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@spp/ui-label')(_Label2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-label/lib/cjs/index.js
 ** module id = 523
 ** module chunks = 1
 **/